export class UserNotifications {
    actionsTotal: number;
    messagesTotal: number | 0 | -1;       // -1 indicates there are unread messages but we haven't counted them.
    myHomeActionsTotal: number;
    myHomeMessagesTotal: number | 0 | -1; // -1 indicates there are unread messages but we haven't counted them.
    myHomeTotal: number;
    total: number;
}
